import type { jurisdictions as de } from '../de/jurisdictions';

export const jurisdictions: typeof de = {
  federal: 'Federal',
  model: 'Model codes',
  BW: 'Baden-Württemberg',
  BY: 'Bavaria',
  BE: 'Berlin',
  BB: 'Brandenburg',
  HB: 'Bremen',
  HH: 'Hamburg',
  HE: 'Hesse',
  MV: 'Mecklenburg-Western Pomerania',
  NI: 'Lower Saxony',
  NW: 'North Rhine-Westphalia',
  RP: 'Rhineland-Palatinate',
  SL: 'Saarland',
  SN: 'Saxony',
  ST: 'Saxony-Anhalt',
  SH: 'Schleswig-Holstein',
  TH: 'Thuringia',
};
